import type { ArticleRow } from '../schemas/article';

export interface ArticlePagePartition {
  items: ArticleRow[];
  hasMore: boolean;
}

/** Splits a probed fetch (limit = pageSize + 1) into visible items and hasMore. */
export function partitionArticlePage(
  fetched: ArticleRow[],
  pageSize: number,
): ArticlePagePartition {
  if (fetched.length > pageSize) {
    return { items: fetched.slice(0, pageSize), hasMore: true };
  }
  return { items: fetched, hasMore: false };
}
